export interface PasswordStrength {
  score: number;
  label: 'Weak' | 'Fair' | 'Good' | 'Strong';
  color: string;
  feedback: string[];
}

export const validatePasswordStrength = (password: string): PasswordStrength => {
  const feedback: string[] = [];
  let score = 0;

  if (password.length >= 8) {
    score += 1;
  } else {
    feedback.push('At least 8 characters');
  }

  if (/[a-z]/.test(password)) {
    score += 1;
  } else {
    feedback.push('One lowercase letter');
  }

  if (/[A-Z]/.test(password)) {
    score += 1;
  } else {
    feedback.push('One uppercase letter');
  }

  if (/[0-9]/.test(password)) {
    score += 1;
  } else {
    feedback.push('One number');
  }

  if (/[^A-Za-z0-9]/.test(password)) {
    score += 1;
  } else {
    feedback.push('One special character');
  }

  let label: 'Weak' | 'Fair' | 'Good' | 'Strong';
  let color: string;

  if (score <= 2) {
    label = 'Weak';
    color = 'text-destructive';
  } else if (score === 3) {
    label = 'Fair';
    color = 'text-orange-500';
  } else if (score === 4) {
    label = 'Good';
    color = 'text-yellow-500';
  } else {
    label = 'Strong';
    color = 'text-green-500';
  }

  return { score, label, color, feedback };
};
